import { Vector3 } from "@babylonjs/core/Maths/math.vector.js";
import { StackPanel } from "@babylonjs/gui/2D/controls/stackPanel.js";
import { ObjectBuilder, Image3D, MeshUtils, ProgressBar3D } from "@dreamcam/babylon-tools";
import { Env } from "../../settings/Env";
import { AppView } from "../AppView";
import { createVector3 } from "../ButtonAnimation";
import { DcRenderingGroup } from "../DcRenderingGroup";
import { MeshName } from "../MeshName";
export class ProgressBar {
    constructor() {
        this._lastTick = 0;
        this._renderObserver = null;
        this._beforeRender = (s) => {
            const nowMs = Date.now();
            if (!this._startTimeMs) {
                this._startTimeMs = nowMs;
            }
            const workingTime = nowMs - this._startTimeMs;
            if (workingTime > Env.broadcast.controller.longPressDuration) {
                return;
            }
            this._progressBar.value = workingTime / Env.broadcast.controller.longPressDuration;
            if (s.activeCamera && this._mesh2D.isVisible) {
                const tick = Date.now();
                const cameraRay = s.activeCamera.getForwardRay();
                const currentDirection = new Vector3();
                const cameraDirection = cameraRay.direction.multiplyByFloats(Env.broadcast.progressBar.position.z, Env.broadcast.progressBar.position.z, Env.broadcast.progressBar.position.z).add(s.activeCamera.position);
                Vector3.SmoothToRef(this._mesh2D.mesh.absolutePosition, cameraDirection, tick - this._lastTick, Env.broadcast.progressBar.lerpTime, currentDirection);
                this._mesh2D.mesh.setAbsolutePosition(currentDirection);
                this._mesh2D.mesh.lookAt(Vector3.Zero());
                this._mesh2D.mesh.rotate(Vector3.Up(), Math.PI);
                this._lastTick = tick;
            }
        };
        const appView = AppView.getInstance();
        const p = Env.broadcast.progressBar;
        this._mesh2D = MeshUtils.createPlaneMesh(MeshName.progressBar, p.width, p.height, appView.scene, appView.guiRootNode, DcRenderingGroup.topmostDialogs);
        this._mesh2D.mesh.position = createVector3(p.position);
        this._progressBar = new ProgressBar3D("progressBar");
        this._progressBar.cornerRadius = this._mesh2D.m2px(p.cornerRadius);
        this._progressBar.background = p.background;
        this._progressBar.progressBarColor = p.color;
        this._mesh2D.texture.addControl(this._progressBar);
        const stackPanel = new StackPanel("progressBarStackPanel");
        stackPanel.isVertical = false;
        stackPanel.spacing = this._mesh2D.m2px(p.spacing);
        this._progressBar.addControl(stackPanel);
        this._iconLeft = new Image3D("progressBarIconLeft");
        this._iconLeft.widthInPixels = this._mesh2D.m2px(p.icon.width);
        this._iconLeft.heightInPixels = this._mesh2D.m2px(p.icon.height);
        stackPanel.addControl(this._iconLeft);
        this._textBlock = ObjectBuilder.createTextBlock3D(this._mesh2D, "progressbarText", "", p.text);
        stackPanel.addControl(this._textBlock);
        this._iconRight = new Image3D("progressBarIconRight");
        this._iconRight.widthInPixels = this._mesh2D.m2px(p.icon.width);
        this._iconRight.heightInPixels = this._mesh2D.m2px(p.icon.height);
        stackPanel.addControl(this._iconRight);
        this.hide();
    }
    hide() {
        if (!this._mesh2D.mesh.isVisible) {
            return;
        }
        MeshUtils.hide(this._mesh2D);
        const appView = AppView.getInstance();
        appView.scene.onBeforeRenderObservable.remove(this._renderObserver);
        this._startTimeMs = undefined;
    }
    show(text, icon, iconPosition) {
        if (this._mesh2D.mesh.isVisible) {
            return;
        }
        if (iconPosition === "left")
            this._iconLeft.source = icon;
        else
            this._iconRight.source = icon;
        this._iconLeft.isVisible = iconPosition === "left";
        this._iconRight.isVisible = iconPosition === 'right';
        this._textBlock.text = text;
        this._progressBar.value = 0;
        MeshUtils.show(this._mesh2D, { isPickable: false });
        const appView = AppView.getInstance();
        this._lastTick = Date.now();
        this._renderObserver = appView.scene.onBeforeRenderObservable.add(this._beforeRender);
    }
}
